import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import axios from "axios";
import { Url } from "../../Api/Api";
import { getAccessToken } from "../../hooks/useLocalStorage";
import Swal from "sweetalert2";
import { useEffect } from "react";

export default function QuerySolutionPage({ row, getAdminDetails }) {
  const [open, setOpen] = React.useState(false);

  const textFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "background.default",
    },
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [querySubmitLoader, setQuerySubmitLoader] = useState(false);

  const [form, setForm] = useState("");
  const [queryId, setQueryId] = useState("");

  console.log(form, "formform");

  const token = getAccessToken();

  const SubmitSolution = async (e) => {
    e.preventDefault();
    setQuerySubmitLoader(true);
    const payload = {
      adminId: row.adminId,
      responseStatement: form,
      supportId: row.supportId,
    };

    try {
      const response = await axios.post(Url.Post_SolveAdminQuery, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      getAdminDetails();
      handleClose();
      Swal.fire({
        title: response?.data?.status === "1" ? "Success" : "Warning!",
        text: response?.data?.message,
        icon: response?.data?.status === "1" ? "success" : "warning",
        confirmButtonText: "Close",
        iconColor: "#00BFFF",
        confirmButtonColor: "#80278C",
      });
    } catch (e) {
      console.log(e, "error");
    } finally {
      setQuerySubmitLoader(false);
      setForm("");
    }
  };

  return (
    <React.Fragment>
      <IconButton
        onClick={handleClickOpen}
        sx={{
          background:
            "linear-gradient(90deg,rgba(20, 165, 222, 1) 0%, rgba(100, 29, 171, 1) 80%)",
        }}
      >
        <MessageIcon
          sx={{
            color: "white",
            borderRadius: "4px",
          }}
        />
      </IconButton>
      <Dialog
        open={open}
        fullWidth
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          paddingX={2}
          paddingY={1}
        >
          <Typography
            color="#001138"
            variant="h6"
            fontWeight={400}
            lineHeight={1.6}
          >
            Admin Query
          </Typography>
          <Box>
            <IconButton
              sx={{ background: "lightgray", height: 40 }}
              onClick={handleClose}
            >
              <CloseRoundedIcon fontSize="25px" />
            </IconButton>
          </Box>
        </Stack>
        <Divider variant="middle" />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {row?.queryStatement}
          </DialogContentText>
        </DialogContent>
        <Box p={2}>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              <Typography component="span">Solution</Typography>
            </AccordionSummary>
            <form onSubmit={SubmitSolution}>
              <AccordionDetails>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Solve query here..."
                  multiline
                  rows={4}
                  value={row?.responseStatement || form}
                  onChange={(e) => setForm(e.target.value)}
                  inputProps={{ maxLength: 1000 }}
                  sx={textFieldStyles}
                  required
                />
              </AccordionDetails>
              <AccordionActions sx={{ paddingY: 3 }}>
                <Button
                  // disabled={querySubmitLoader}
                  disabled={
                    querySubmitLoader || row?.status?.toLowerCase() === "closed"
                  }
                  sx={{
                    background: "#51B0CF",
                    width: "30%",
                    ":hover": { background: "#51B0CF", color: "#fff" },
                  }}
                  type="submit"
                  size="small"
                  variant="contained"
                >
                  {querySubmitLoader ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </AccordionActions>
            </form>
          </Accordion>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
